import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import SingleCategory from "../../components/_Blog/SingleCategory/SingleCategory";
import HeadComponent from "../../components/HeadComponent/HeadComponent";
import FivaLayout from "../../Layout/FivaLayout";
var Category = function(param) {
    var data = param.data, topics = param.topics;
    var headerProps = {
        title: data ? data.headers.title : "",
        keywords: data ? data.headers.keywords : "",
        content: data ? data.headers.content : ""
    };
    return /*#__PURE__*/ _jsxs(FivaLayout, {
        blue: false,
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(SingleCategory, {
                category: data,
                topics: topics
            })
        ]
    });
};
export var __N_SSG = true;
export default _withSuperJSONPage(Category);
